import { post } from "../utils/http"

function getMemberInfo() {
    const url = "/v1/member/info";
    return post({ url });
}

export default {
    getMemberInfo
}